import { QueryClient } from '@tanstack/react-query';

// Single shared client so the React tree and the imperative helpers
// (authCache adapter, mutation invalidations) all hit the same cache.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
